import React from 'react';
import PublicActivityPacks from '../containers/PublicActivityPacks.jsx';

export default (props) => (
  <PublicActivityPacks {...props} />
);
